module.exports = __webpack_public_path__ + "static/media/sizeguide_N_807.23ad30d5.jpg";